import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { LocaleService } from '@app/system/services/locale.service';

@Component({
	selector: 'app-popup',
	templateUrl: './popup.component.html',
	styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {


	showFrame = 'frame';
	videoSrc = '';

	constructor(
		private iconRegistry: MatIconRegistry,
		private sanitizer: DomSanitizer,
		public locale: LocaleService,
		public dialogRef: MatDialogRef<PopupComponent>,

		@Inject(MAT_DIALOG_DATA) public data: any = {}
	) {
		iconRegistry.addSvgIcon('next', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/next.svg'));
		iconRegistry.addSvgIcon('back', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/back.svg'));
		iconRegistry.addSvgIcon('play', sanitizer.bypassSecurityTrustResourceUrl('/assets/svg/play.svg'));
	}

	ngOnInit(): void {
	}

	ngAfterViewInit() {
		const dialogData: any = this.data;
		this.videoSrc = dialogData.videoSrc;
	}

	selectFrame(video) {
		if (navigator.onLine) {
			this.showFrame = 'cover';
			video.pause();
		}
	}

	playVideo(video) {
		if (navigator.onLine) {
			this.showFrame = 'frame';
			video.play();
		}
	}

	jumpDuration(video, type) {
		if (navigator.onLine) {
			if (type === 'forward') {
				video.currentTime = video.currentTime + 0.1;
			} else {
				video.currentTime = video.currentTime - 0.1;
			}
		}
	}

	async setThumbnail(video) {
		if (navigator.onLine) {
			const canvas = document.createElement('canvas');
			canvas.height = this.data.height;
			canvas.width = this.data.width;
			const ctx = canvas.getContext('2d');
			const img = new Image();
			ctx.drawImage(video, 0, 0, this.data.width, this.data.height);
			img.src = canvas.toDataURL("image/jpg");
			const file = await this.srcToFile(img.src, `thumbnail.jpg`, 'image/jpg');
			this.dialogRef.close({
				src: img.src,
				file
			});
		}
	}

	srcToFile(src, fileName, mimeType) {
		return fetch(src)
			.then((res) => {
				return res.arrayBuffer();
			})
			.then((buf) => {
				return new File([buf], fileName, { type: mimeType });
			});
	}

}
